import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {BrowserUpdatedRounded} from "@mui/icons-material";
import {LoadingButton} from "../../../theme/components/LoadingButton";

const UpdateAppModal = (props) => {

    const {open, onClose, onConfirm, ...restProps} = props;

    return <Dialog open={open} onClose={onClose} {...restProps} PaperProps={{ sx: { p: {xs: 1.5, lg: 2}, minWidth: {xs: "90%", lg: "25vw"} } }}>
        <Box mt={2} display="flex" alignItems="center" justifyContent="center">
            <BrowserUpdatedRounded color="success" sx={{ fontSize: "4rem" }}/>
        </Box>
        <DialogTitle sx={{ textAlign: "center" }}>نسخه جدید اپ در دسترس می باشد</DialogTitle>
        <DialogContent>آیا مایل هستید بروزرسانی کنید؟!</DialogContent>
        <DialogActions sx={{ flexDirection: {xs: "column", lg: "row"} }}>
            <Button onClick={onClose} color="success" variant="outlined" fullWidth sx={{ py: 1.5, mt: {xs: 1.5, lg: 0} }} disableElevation>لغو</Button>
            <LoadingButton
                onClick={onConfirm} variant="contained" color="success"
                fullWidth sx={{ py: 1.5, ml: {xs: "0!important", lg: "8px!important"}, mt: {xs: 1, lg: 0} }} disableElevation>تایید</LoadingButton>
        </DialogActions>
    </Dialog>
}
export default UpdateAppModal;